<template>
    <div class="modal modal-todo modal-send-to-lost fade" tabindex="-1" role="dialog" aria-labelledby="send-to-lost-modal-label" aria-hidden="true" ref="modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Decline to {{ type === 'follow-up' ? 'Follow up schedule' : 'Lost' }} - {{ name }}</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="declineRequest">
                        <div class="form-group">
                            <label for="lost-notes">Notes</label>
                            <textarea id="lost-notes" class="form-control" v-model="notes" rows="4" placeholder="Type here..."></textarea>
                            <div v-if="validationError" class="text-small text-danger">{{ validationError }}</div>
                        </div>
                        <button type="submit" class="btn btn-submit btn-block mt-3 btn-primary">
                            Save
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DeclineRequestModal',
    data() {
        return {
            id: 0,
            name: '',
            type: '',
            notes: '',
            validationError: ''
        }
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    methods: {
        openModal({ id, name, type }) {
            this.id = id;
            this.name = name;
            this.type = type;
            this.notes = '';
            this.validationError = '';

            this.$nextTick(() => {
                $(this.$refs.modal).modal({
                    backdrop: 'static',
                    keyboard: false
                });
            });
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');

            this.id = 0;
            this.name = '';
            this.type = '';
            this.notes = '';
            this.validationError = '';
        },
        declineRequest() {
            if (!this.notes) {
                this.validationError = 'Please write some notes.';
                return;
            }

            this.validationError = '';
            this.$emit('save', this.id, 'reject', this.type, this.notes);
            this.closeModal();
        }
    }
}
</script>
